var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"rsp__header-c"}},[_c('CardLayoutLogo'),_c('CardLayoutTitle',[_vm._v(" Crie uma nova senha ")]),_c('PasswordStatus')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }